import { lazy, Suspense } from "react";
import { useAuth } from "@/hooks/useAuth";
import { ClubDashboard } from "./ClubDashboard";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { Trophy } from "lucide-react";

const LazyDashboard = lazy(() =>
  import("../App").then((m) => ({ default: m.Dashboard })),
);

function DashboardFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <Trophy className="h-12 w-12 text-primary mx-auto mb-4 animate-pulse" />
        <p className="text-muted-foreground">Cargando...</p>
      </div>
    </div>
  );
}

export function AuthRoot() {
  const { user } = useAuth();
  if (user?.userType === "club") {
    return <ClubDashboard />;
  }
  return (
    <ErrorBoundary>
      <Suspense fallback={<DashboardFallback />}>
        <LazyDashboard />
      </Suspense>
    </ErrorBoundary>
  );
}
